import { CountryWithCurrencyOption } from 'types/dictionaries';

export interface RawCountryWithCurrencyEntry {
  name: string;
  currency: string;
}

export type RawCountryWithCurrencyDictionary = Record<
  string,
  RawCountryWithCurrencyEntry
>;

const formatCountryWithCurrencyDictionary = (
  data: RawCountryWithCurrencyDictionary
): CountryWithCurrencyOption[] =>
  Object.entries(data).map(([countryCode, { name, currency }]) => ({
    countryCode,
    countryName: name,
    currency
  }));

export default formatCountryWithCurrencyDictionary;
